import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Html = React.lazy(() => import(
  /* webpackChunkName: "ricos_plugin_html_lazy" */
  "./html.js"
));
const HtmlRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Html,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const HtmlLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(HtmlRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.HTML]: HtmlLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
